import { Calendar, CalendarChangeEvent } from '@progress/kendo-react-dateinputs';
import BookingCalendarCell from './BookingCalendarCell';

interface BookingCalendarProps {
  availableDates?: Date[];
  value: Date;
  onChange: (event: CalendarChangeEvent) => void;
}

export const BookingCalendar = ({ availableDates, value, onChange }: BookingCalendarProps) => {
  const CustomCell = (props: any) => (
    <BookingCalendarCell {...props} availableDates={availableDates} />
  );

  return (
    <Calendar
      cell={CustomCell}
      value={value}
      onChange={(e: any) => {
        onChange(e);
      }}
    />
  );
};

export default BookingCalendar;
